import {AbstractControl} from '@angular/forms';

/**
 * Liefert einen verständlichen Fehlertext für ein ungültiges, bereits berührtes Formularfeld.
 * Gibt null zurück, solange das Feld gültig oder noch nicht berührt ist.
 */
export function getFormControlErrorMessage(control: AbstractControl | null | undefined): string | null {
  if (!control || !control.invalid || !(control.touched || control.dirty)) {
    return null;
  }
  const errors = control.errors ?? {};
  if (errors['required']) {
    return 'Dieses Feld ist ein Pflichtfeld.';
  }
  if (errors['blank']) {
    return 'Die Eingabe darf nicht nur aus Leerzeichen bestehen.';
  }
  if (errors['email']) {
    return 'Bitte eine gültige E-Mail-Adresse eingeben.';
  }
  if (errors['zipCode']) {
    return control.parent?.get('country')?.value === 'DEU'
      ? 'Die Postleitzahl muss aus 5 Ziffern bestehen.'
      : 'Bitte eine gültige Postleitzahl eingeben.';
  }
  if (errors['pattern']) {
    return 'Die Eingabe hat ein ungültiges Format.';
  }
  if (errors['maxlength']) {
    return `Maximal ${errors['maxlength'].requiredLength} Zeichen erlaubt.`;
  }
  if (errors['minlength']) {
    return `Mindestens ${errors['minlength'].requiredLength} Zeichen erforderlich.`;
  }
  if (typeof errors['scheduleConflict'] === 'string') {
    return errors['scheduleConflict'];
  }
  return 'Die Eingabe ist ungültig.';
}
